import axios from "axios";
import store from "@/store";
import router from '@/router/index';

const http = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    timeout: 20000
});

function success(result) {
    // store.commit(API_SUCCESS);
    return Promise.resolve(result);
}

function failure(error) {
    // store.commit(API_FAILURE, error);
    if (error.response.status === 401) {
        store.dispatch("ACTION_LOGOUT");
        router.push({name: "Login"});
    }

    return Promise.reject(error);
}

function doAuthenticated(state) {
    if (state && state.api && state.api.token) {
        http.defaults.headers["Authorization"] = "Bearer " + state.api.token;
    } else {
        delete http.defaults.headers["Authorization"];
    }
    return http;
}

const httpService = {
    get(url, request) {
        // store.commit(API_IN_PROGRESS);
        return doAuthenticated(store.state)
            .get(url, request)
            .then(response => success(response.data))
            .catch(error => failure(error));
    },
    post(url, request) {
        // store.commit(API_IN_PROGRESS);
        return doAuthenticated(store.state)
            .post(url, request)
            .then(response => success(response.data))
            .catch(error => failure(error));
    },
    put(url, request) {
        return doAuthenticated(store.state)
            .put(url, request)
            .then(response => success(response.data))
            .catch(error => failure(error));
    },
    patch(url, request) {
        // store.commit(API_IN_PROGRESS);
        return doAuthenticated(store.state)
            .patch(url, request)
            .then(response => success(response.data))
            .catch(error => failure(error));
    },
    delete(url, request) {
        // store.commit(API_IN_PROGRESS);
        return doAuthenticated(store.state)
            .delete(url, request)
            .then(response => success(response.data))
            .catch(error => failure(error));
    }
};

export default httpService;
